import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 55vh;
`;

export const Title = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
  color: #333333;
`;

export const Table = styled.div``;

export const TableHeader: any = styled.div`
  display: flex;
  flex-direction: row;
  background-color: rgba(0, 0, 0, 0.04);
  padding: 8.5px 18px 8.5px 24px;
  border-radius: 8px;
  min-height: 40px;
  align-items: center;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  margin-top: 8px;
  margin-right: ${(props: any) => props?.mg}px;
  max-height: 50px;
`;

export const HeaderText = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #000000;
  text-overflow: ellipsis;
`;

export const Cell: any = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  text-overflow: ellipsis;
`;

export const CellSmall: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 50px;
  text-overflow: ellipsis;
`;
export const Row: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 200px;
`;

export const RowAlign: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RowSpace: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  max-height: 45px;
  padding: 0 32px 8px 0;
`;

export const ContainerPagination = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100% !important;
  padding: 16px 28px 0 0;
`;

export const Body = styled.div`
  display: flex;
  width: 100% !important;
  flex-direction: column;
  overflow: auto;
  padding: 0 32px 0 0;

  height: 100%;

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px; /* Add rounded corners to the scrollbar thumb */
  }
`;
